<ng-container *ngIf="customerLanding$ | async; let customerLanding; else: loading">
    <div
        class="login-top-part-wrapper"
        fxLayout="column"
        fxLayoutAlign="center center"
        [ngStyle]="{ 'background-image': 'url(' + customerLanding.background_url + ')' }"
    >
        <div class="layer"></div>
        <app-login-form (onLoginSuccess)="routeAfterLogin()"></app-login-form>
    </div>
</ng-container>

<ng-template #loading>
    <app-kd-logo-loading></app-kd-logo-loading>
</ng-template>
